var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABIFBMVEX6+vr4+Pjz8/Pw8PDy 8vL19fX5+fnKycmtrKy3trbOzc3l5eXx8fHn5ubq6em7urqPjo6MioqTkZGqqanNzMzt7e3u7e3U 09O7ubmqqKixsLDZ2Ni6urqOjY2KiIiLiYmZl5fBwMDr6+v39/fj4uK6ubmamJiNi4ubmprS0dGW lJTGxcXj4+Ovrq6Qjo6PjY2enZ3c3Nzs6+u2tbW5uLjPz8+Vk5Pp6Oi1tLTT0tK9vLySkZGUkpLp 6emioKDV1NS3tbW4t7eWlZXDwsLQz8/u7u7m5uabmZmmpaXq6uqlpKSdnJza2tq8u7uura3Z2dmV lJTDw8O2tLSXlZWzsbHi4eHLysqnpqafnZ308/OurKzIx8fd3Nz29vbz8vL///9sg8stAAAAAWJL R0Rfc9FRLQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+IMEgcBAlriJNQAAAEDSURBVBjT VdHpVsIwEAXgSZdBbVCLqCgawABFLBVtUavUFVRE3Pft/R/DtKFQ7q/kO0nOmRuAOERRNZ0gjIOI WmpqesZQMGYkNG3Mzs2bmYXs4vAwWVrOrazm19YZKxRLGyEiL1eqFqttVgQyVt+iKK7aDUdsBG6H yJo7HHDXtVgSTY+C3tpjEnMSWXMf1AO5rPmHR1aUdhmC4yGe+J4b5vQsAKMo8fzC77REfLvL4bIq 0axfRbnOc4DeDZtI/5YAaANzAu8CMRG/7yftIaULRPWxPTbnKYhGJ8HguRDby6ssCUnv7T0jHjad j1Kajwr+tLNe48v9/qGIid5/FUr/Rp/xD5G4LXKAGMUXAAAAkGVYSWZJSSoACAAAAAUAGgEFAAEA AABKAAAAGwEFAAEAAABSAAAAKAEDAAEAAAACAAAAMQECAAsAAABaAAAAaYcEAAEAAABmAAAAAAAA AEgAAAABAAAASAAAAAEAAABQaG90b1NjYXBlAAADAAGgAwABAAAAAQAAAAKgBAABAAAAFAAAAAOg BAABAAAAFAAAAAAAAADW3QgJAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTEyLTE4VDE0OjAxOjAy LTA3OjAwSDk6JwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0xMi0xOFQxNDowMTowMi0wNzowMDlk gpsAAAARdEVYdGV4aWY6Q29sb3JTcGFjZQAxD5sCSQAAABd0RVh0ZXhpZjpFeGlmSW1hZ2VMZW5n dGgAMjCT51/BAAAAFnRFWHRleGlmOkV4aWZJbWFnZVdpZHRoADIw3hXiRAAAABN0RVh0ZXhpZjpF eGlmT2Zmc2V0ADEwMnNCKacAAAAYdEVYdGV4aWY6U29mdHdhcmUAUGhvdG9TY2FwZXTZmyQAAAAA SUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartGray);
export default __webpack_public_path__ + "static/media/chart-gray.96165819ecdab7cef62e60a8798f6ec5.svg";
export { ForwardRef as ReactComponent };